import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';
import * as fromState from './state';

export const reducer = createReducer(
  fromState.initialState,
  on(fromActions.checkReservarionChannelRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fromActions.checkReservarionChannelSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),
  on(fromActions.checkReservarionChannelFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(fromActions.resetState, () => fromState.initialState),
);

export function checkReservationChannelReducer(
  state: fromState.State | undefined,
  action: Action,
) {
  return reducer(state, action);
}
